/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ShepherdTour } from 'react-shepherd';
import { firstSteps, tourOptions } from './steps';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setExperiencesAll } from 'store/actions/experienceDetails/master';
import { experienceDetailsAction } from 'store/actions/experienceDetails/generic';
import { fetchMyPublishedExps, fetchPublishedExpData, genericMutation, fetchUsersListAdmin, deleteExperience } from 'fetch/experiences';
//  import { defaultMarketing } from 'constants/experiencesConsts';
import {
    togglePrintMode,
    toggleEdit,
    toggleFeedbackMode,
    toggleSuperAdmin,
    setIsOwnerMode,
    setIsAdminStaffMode,
    setIsEduContentMode
} from 'store/actions/globalState/master';
import uiStruct from 'constants/uiStruct';
import translations from 'constants/translations';
import ExperienceList from 'components/blocks/ExperienceList';
import { AxiosAbortService } from 'helpers/AxiosAbortService';
import { clearAllExperiences } from 'store/actions/experienceDetails/general';
import { handleRowReverse } from 'helpers/FEutils';
import * as types from 'store/actions/types';
import LayoutMenuListEdit from 'components/layouts/LayoutMenuListEdit';
import 'styles/shepherd.css';
import { useScroll } from 'helpers/useScroll';
import { deletePublishedMutation } from 'helpers/graphql';
import useStatuses from 'helpers/useStatuses';
import {
    // isPublishedViewFunc,
    isAdminStaffFunc
} from 'helpers/statusHelper';
import LayoutHelpBar from 'components/layouts/LayoutHelpBar';
import { setPagination } from 'store/actions/globalState/master.js';
import classNames from 'classnames';
import RecommendBar from 'components/blocks/RecommendBar';
import LayoutNavbar from 'components/layouts/LayoutNavbar';


const PagePublished = (props) => {
    const {
        toggleEdit,
        togglePrintMode,
        toggleFeedbackMode,
        toggleSuperAdmin,
        setIsOwnerMode,
        setIsAdminStaffMode,
        setIsEduContentMode,
        globalState: {
            inMode,
            lang,
            // siteData,
            isSuperAdmin,
            pagination: { currentPage }
        },
        auth,
        auth: {
            user: { role: userRole }
        },
        experiences: { experiences, totalExperiences },
        fetchMyPublishedExps,
        clearAllExperiences,
        experienceDetailsAction,
        fetchPublishedExpData,
        genericMutation,
        fetchUsersListAdmin,
        deleteExperience,
        setPagination
    } = props;
    const { isOwner, isEduContent } = useStatuses();
    const isAdminStaff = isAdminStaffFunc(userRole);
    const currentPaginationPage = useRef(0); // Store the current pagination from home page
    // so can be restored when leaving the page
    useEffect(() => {
        setIsAdminStaffMode(isAdminStaff);
        setIsEduContentMode(isEduContent);
    }, [isAdminStaff, isEduContent]);

    useEffect(() => {
        setIsOwnerMode(false);
        togglePrintMode(false);
        toggleFeedbackMode(false);
        toggleSuperAdmin(false);
        toggleEdit(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const showHeader = useScroll();
    const rtl = !!translations[lang].rtl;
    const currentViewMode = useRef(inMode);
    const [pageLoad, setPageLoading] = useState(true);
    const fetchExperiences = () => {
        if (inMode === 'owned') {
            experienceDetailsAction({
                type: types.SET_TO_PUBLISHED,
                dataObj: 'kreo'
            });
        } else {
            fetchMyPublishedExps(true).then((res) => {
                setPageLoading(false);
            });
        }
    };
    const [totExpDisplayed, setTotExpDisplayed] = useState(0);
    const handleDeleteExperience = (expId, pubId) => {
        setPageLoading(true);
        if (inMode === 'marketplace') {
            fetchPublishedExpData(expId).then((res) => {
                if (res.action) {
                    genericMutation(deletePublishedMutation(pubId, expId), types.DELETE_PUBLISHED).then(() => {
                        fetchExperiences();
                    });
                }
            });
        } else {
            deleteExperience(expId).then(() => {
                fetchExperiences();
            });
        }
    };

    useEffect(() => {
        if (inMode !== currentViewMode.current) {
            currentViewMode.current = inMode;
            setPageLoading(true);
            fetchExperiences(true);
        }
    }, [inMode]);

    useEffect(() => {
        currentPaginationPage.current = currentPage;
        setPagination(0);
        if (isAdminStaff) {
            fetchUsersListAdmin();
        }
        return () => {
            setPagination(currentPaginationPage.current);
            AxiosAbortService.clearRequest('allExperiences');
            clearAllExperiences();
        };
    }, []);

    return auth.isProfile ? (
        <ShepherdTour steps={firstSteps} tourOptions={tourOptions}>
            <LayoutNavbar />
            {/* <LayoutHelpBar /> */}
            <div className='w-full mt-36 md:mt-36'>
                <LayoutMenuListEdit
                    rtl={rtl}
                    isOwner={isOwner}
                    isAdminStaff={isAdminStaff}
                    isSuperAdmin={isSuperAdmin}
                    handleSuperAdmin={toggleSuperAdmin}
                    showHeader={showHeader}
                />
                <RecommendBar />
                <div
                    className={`relative 
                        max-w-2xl md:max-w-3xl lg:max-w-4xl xl:max-w-6xl mx-auto pt-12 md:pt-0 px-0 md:px-4 lg:px-0`}
                >
                    <div className='flex justify-between items-center mb-4 px-4'>
                        <div
                            className={`${handleRowReverse(rtl).rtl
                                }  text-transparent bg-clip-text bg-gradient-to-tr from-gray-900 via-blue-500 to-green-400 text-3xl md:text-4xl leading-none  font-bold l py-2 `}
                        >
                            {isAdminStaff ? 'Published Kreations' : 'My Published Kreations'}
                        </div>
                    </div>
                    <div className={classNames('flex flex-col gap-2 w-full mb-8 text-sm md:text-sm px-4 ')}>
                        <div>You can manage pricing, booking and orders of your Approved Experiences here.</div>
                        <div className='flex items-center gap-2 flex-wrap'>
                            To edit and experience go back to
                            <Link
                                className='bg-green-100 text-xs text-green-600 rounded-lg px-3 py-1 flex items-center w-max gap-2 hover:bg-gray-900 hover:text-white'
                                to={`${process.env.REACT_APP_BASENAME_EXPERIENCE}/all`}
                            >
                                <i className='ri-store-line text-lg'></i>
                                <span>My Kreations</span>
                            </Link>
                        </div>
                    </div>

                    <ExperienceList
                        inMode={inMode}
                        viewPublished={true}
                        isAdminStaff={false}
                        setTotExpDisplayed={setTotExpDisplayed}
                        totExpDisplayed={totExpDisplayed}
                        fetchExperiences={fetchExperiences}
                        setPageLoading={setPageLoading}
                        pageLoad={pageLoad}
                        experiences={experiences}
                        totalExperiences={totalExperiences}
                        handleNewLabel={translations[lang][uiStruct.ui.experience.add_experience]}
                        handleDeleteExperience={handleDeleteExperience}
                        myPublished={true}
                    />
                </div>
            </div>
        </ShepherdTour>
    ) : (
        <Navigate to='/c/accounts/profile' />
    );
};

const mapStateToProps = (state) => ({
    experienceDetails: state.experienceDetails,
    experiences: state.experiences,
    globalState: state.globalState,
    auth: state.auth
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            toggleEdit,
            togglePrintMode,
            toggleFeedbackMode,
            setExperiencesAll,
            fetchMyPublishedExps,
            clearAllExperiences,
            toggleSuperAdmin,
            experienceDetailsAction,
            fetchPublishedExpData,
            genericMutation,
            fetchUsersListAdmin,
            setIsOwnerMode,
            setIsAdminStaffMode,
            setIsEduContentMode,
            deleteExperience,
            setPagination
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(PagePublished);
